module.exports = __webpack_public_path__ + "img/img4_icon.576943c5.png";